import type { FC, SVGProps } from "react";

const IconGreenFormula: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M9.99973 19C8.24379 19.0053 6.54999 18.3505 5.25425 17.1654C3.95852 15.9803 3.1555 14.3515 3.00447 12.6021C2.85344 10.8527 3.36543 9.11036 4.43888 7.72074C5.51234 6.33112 7.06886 5.3957 8.79974 5.1C14.4997 4 15.9997 3.48 17.9997 1C18.9997 3 19.9997 5.18 19.9997 9C19.9997 14.5 15.2197 19 9.99973 19Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 20C1 17 2.85 14.64 6.08 14C8.5 13.52 11 12 12 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconGreenFormula;
